import { IonRouterLink } from "@ionic/react";
import { FormattedMessage } from "react-intl";

import styles from "@components/popovers/Popover.module.css";
import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";
import { IconName } from "@utils/iconUtils";

type Props = {
  disabled?: boolean;
  icon: IconName;
  iconColor?: "primary" | "success-500";
  noBorder?: boolean;
  onClick?: () => void;
  routerLink?: string;
  textKey: string;
};

const PopoverItem = ({
  disabled = false,
  icon,
  iconColor = "primary",
  noBorder,
  onClick,
  routerLink,
  textKey
}: Props) => (
  // eslint-disable-next-line react/forbid-elements
  <IonRouterLink
    className={disabled ? styles.disabledItem : ""}
    onClick={disabled ? undefined : onClick}
    routerLink={routerLink}
  >
    <div className={`${styles.popoverItem} ${noBorder ? styles.noBorder : ""}`}>
      <Icon color={disabled ? "gray-500" : iconColor} icon={icon} />
      <BodyCopy color={disabled ? "gray-500" : "primary"} size="small">
        <FormattedMessage id={textKey} />
      </BodyCopy>
    </div>
  </IonRouterLink>
);

export default PopoverItem;
